const resolveLocale = (language: string) =>
  language.toLowerCase().startsWith('fa') ? 'fa-IR' : 'en-US';

export const formatDate = (
  date: string | Date,
  language: string,
  options: Intl.DateTimeFormatOptions
) => new Intl.DateTimeFormat(resolveLocale(language), options).format(new Date(date));

export const formatNumber = (
  value: number,
  language: string,
  options?: Intl.NumberFormatOptions
) => new Intl.NumberFormat(resolveLocale(language), options).format(value);

export const formatCurrency = (
  value: number,
  language: string,
  currency = 'EUR'
) =>
  new Intl.NumberFormat(resolveLocale(language), {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(value);

export const formatConvertedCurrency = (
  convertedAmount: number,
  language: string,
  targetCurrency: string
) => {
  if (targetCurrency === 'IRR') {
    const rounded = Math.round(convertedAmount / 1000) * 1000;
    return new Intl.NumberFormat(resolveLocale(language), {
      maximumFractionDigits: 0,
    }).format(rounded) + (resolveLocale(language) === 'fa-IR' ? ' تومان' : ' toman'); // "IRR" rates are toman
  }
  return new Intl.NumberFormat(resolveLocale(language), {
    style: 'currency',
    currency: targetCurrency,
    maximumFractionDigits: 0,
  }).format(convertedAmount);
};

/** "3 hours ago" / "۳ ساعت پیش" from an age in hours. */
export const formatAgeHours = (hours: number, language: string) => {
  const rtf = new Intl.RelativeTimeFormat(resolveLocale(language), { numeric: 'auto' });
  if (hours < 1) return rtf.format(0, 'hour');
  if (hours < 48) return rtf.format(-hours, 'hour');
  return rtf.format(-Math.round(hours / 24), 'day');
};
